// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._369f8{border-bottom:1px solid #e0e8f2;border-top:1px solid #e0e8f2;overflow:hidden}.Z6c12{overflow:visible}._1XYxR{cursor:pointer;font-size:14px;font-size:1.4rem;font-weight:700;padding:1rem 0;position:relative}._1XYxR .collapsible__btn{position:absolute;right:0;top:1px}._3-PvY{padding-top:2rem}.OcfWM{font-size:14px;font-size:1.4rem;margin:2rem 0}._1OmjD{border:4rem solid rgba(48,168,255,.1);border-radius:50%;height:250px;height:25rem;position:relative;width:250px;width:25rem}.l8Tsa{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;border:1.5rem solid #30a8ff;border-radius:50%;height:225px;height:22.5rem;justify-content:center;left:-27.5px;left:-2.75rem;position:absolute;top:-27.5px;top:-2.75rem;width:225px;width:22.5rem}._3q9Zc{fill:#30a8ff;height:80px;height:8rem;width:80px;width:8rem}.GMoxx{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;height:251px;height:25.1rem;justify-content:center;width:250px;width:25rem}._3KH9w{height:225px;height:22.5rem;width:225px;width:22.5rem}._22dGW{fill:#30a8ff;height:150px;height:15rem;width:160px;width:16rem}", ""]);
// Exports
exports.locals = {
	"optionalSection": "_369f8",
	"optionalSection--overflow": "Z6c12",
	"optionalSection__header": "_1XYxR",
	"optionalSection__content": "_3-PvY",
	"qrcode__info": "OcfWM",
	"indicatorBackground": "_1OmjD",
	"indicator": "l8Tsa",
	"indicatorIcon": "_3q9Zc",
	"loaderContainer": "GMoxx",
	"loader": "_3KH9w",
	"loaderIcon": "_22dGW"
};
module.exports = exports;
